import bg1 from "../../assets/image_lottery/bg_1.png";
import bg2 from "../../assets/image_lottery/bg_2.png";
import bg3 from "../../assets/image_lottery/bg_3.png";
import item1 from "../../assets/image_lottery/item_1.png";
import item2 from "../../assets/image_lottery/item_2.png";
import bar1 from "../../assets/image_lottery/bar_1.png";
import bar2 from "../../assets/image_lottery/bar_2.png";
import left from "../../assets/image_lottery/left.svg";
import title from "../../assets/image_lottery/title.png";
import close from "../../assets/image_lottery/close.png";
import add from "../../assets/image_lottery/add.png";
import local from "../../assets/image_lottery/local.png";
import success from "../../assets/image_lottery/success.png";
import air from "../../assets/image_lottery/air.png";
import thank from "../../assets/image_lottery/thank.png";

export {
  bg1,
  bg2,
  bg3,
  item1,
  item2,
  bar1,
  bar2,
  left,
  title,
  close,
  add,
  local,
  success,
  air,
  thank
};
